import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/checklist-detail'

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })
  return response
}

export const updateMany = async (data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const remove = async (data) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const create = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const get = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response?.data
}
